import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  changeEaState,
  getNotificationDuty,
  saveEaJsonData,
  saveSignBothData,
  searchSignatureData,
} from '@store/actions/eaAction';
import { showModal } from '@store/actions/commonAction';
import EaHeader from '@components/ea/EaHeader';
import DiseaseInfo from '@components/ea/DiseaseInfo';
import DriveInfo from '@components/ea/DriveInfo';
import HobbyInfo from '@components/ea/HobbyInfo';
import EtcInfo from '@components/ea/EtcInfo';
import NotificationPopup from '@components/ea/NotificationPopup';
import SatModal from '@components/common/satUI/SatModal';
import SatTab from '@components/common/satUI/SatTab';
import { checkProduct } from '@common/utils';

const NotificationEdit = props => {
  const {
    signPasteData,
    signData,
    planMainInfo,
    productInfo,
    genderLabel,
    applicationNo,
    onClickEaBookmark,
    empName,
    bookmark,
    isPracticeMode = false,
    practiceSignName = '',
    practiceSignature = '',
    insuredPrspCustNo,
    complete,
    suitabilityInfo,
    isAddNoticeQ6,
    isStbltDgnsProcExcpt,
  } = props;
  const {
    planEstablishProduct,
    savingProductYN,
    republishType,
    calculateDate,
  } = planMainInfo;

  const { alert } = $hooks.useModal();
  const { saveNotificationDutyToNbs } = $hooks.useApi();
  const {
    contract,
    customer,
    completePage,
    completePdfPage,
    signData: signDataDefatult,
    bundleCodeInfo,
  } = useSelector(state => state.eaReducer);
  const notificationType = $utils.getNotificationType(bundleCodeInfo); // 알릴의무 타입
  const notificationKey = `notificationType${notificationType}`; // 알릴의무 객체 Key: [1~7]
  const notificationInfo = contract.notificationDuty[notificationKey];

  const calculateDateString = calculateDate.replace(/[^0-9]/g, '');
  const isBeforeRevision = calculateDateString < '20250101' ? true : false; // 산출일 25/1/1 이전 -> 계약전알릴의무 표준약관 변경으로 이전양식 호출

  const {
    isEasyProduct,
    isAnnuityProduct,
    isMedicalProduct,
    isFreePickProduct,
    isSecondMajorRider,
    isDementiaProduct,
  } = $utils.getNotificationChecks(notificationType);
  const isSuitabilityProduct = checkProduct(productInfo, '적합성상품'); // 적합성 상품 여부

  const dispatch = useDispatch();

  const { error: toastError } = $hooks.useToast();
  const [activeTab, setActiveTab] = useState('0');
  const [popupVisible, setPopupVisible] = useState(false);

  const [isDiseaseDisabled, setIsDiseaseDisabled] = useState(true);
  const [isDriveDisabled, setIsDriveDisabled] = useState(
    savingProductYN === 'Y' ? false : true,
  );
  const [isHobbyDisabled, setIsHobbyDisabled] = useState(
    isEasyProduct ? false : true,
  );

  const reportId = 'app_form_06';
  const tabDatas =
    isEasyProduct || isMedicalProduct
      ? [
          { label: '질병', value: '1' },
          { label: '운전', value: '2' },
          { label: '기타', value: '4' },
        ]
      : savingProductYN === 'Y' || isAnnuityProduct || isDementiaProduct
      ? [{ label: '질병', value: '1' }]
      : [
          { label: '질병', value: '1' },
          { label: '운전', value: '2' },
          { label: '취미', value: '3' },
          { label: '기타', value: '4' },
        ];

  // 적합성 예외 되는 사람들 (미성년자, 법인, 설계사 고객)
  const isPassCustomerMinor = $utils.checkMinor(customer.owner.legalAge);
  // 전문금융인
  const isProFinance = $utils.checkFinancialExpert(customer.owner);
  // 적합성에 기입한 소득 (적합성 상품일 때만 사용)
  const suitabilityIncome = isSuitabilityProduct
    ? $utils.getSuitabilityIncome(suitabilityInfo, customer.owner)
    : '';

  useEffect(() => {
    if (isEasyProduct) {
      // 간편상품
      const requestData = {
        type: 'contract',
        data: {
          ...contract,
          notificationDuty: {
            ...contract.notificationDuty,
            [notificationKey]: {
              ...contract.notificationDuty[notificationKey],
              category1: {
                ...contract.notificationDuty[notificationKey].category1,

                q07: isSuitabilityProduct
                  ? suitabilityIncome
                  : contract.notificationDuty[notificationKey].category1.q07,
              },
            },
            productType: notificationType,
          },
        },
      };
      handleChangeEaState(requestData);
    } else if (isAnnuityProduct) {
      // 연금상품
      const requestData = {
        type: 'contract',
        data: {
          ...contract,
          notificationDuty: {
            ...contract.notificationDuty,
            notificationType3: {
              ...contract.notificationDuty.notificationType3,
            },
            productType: notificationType,
          },
        },
      };
      handleChangeEaState(requestData);
    } else if (isDementiaProduct) {
      // 치매상품
      const requestData = {
        type: 'contract',
        data: {
          ...contract,
          notificationDuty: {
            ...contract.notificationDuty,
            notificationType7: {
              ...contract.notificationDuty.notificationType7,
              category1: {
                ...contract.notificationDuty.notificationType7.category1,
              },
            },
            productType: notificationType,
          },
        },
      };
      handleChangeEaState(requestData);
    } else {
      const requestData = {
        type: 'contract',
        data: {
          ...contract,
          notificationDuty: {
            ...contract.notificationDuty,
            notificationType1: {
              ...contract.notificationDuty.notificationType1,
              category1: {
                ...contract.notificationDuty.notificationType1.category1,
                q06: { pregnancyPeriod: '', checkYn: '' },
              },
              category4: {
                ...contract.notificationDuty.notificationType1.category4,

                q02: isSuitabilityProduct
                  ? suitabilityIncome
                  : contract.notificationDuty.notificationType1.category4.q02,
              },
            },
            productType: notificationType,
          },
        },
      };

      handleChangeEaState(requestData);
    }

    // 기존 입력된 계약전 알릴의무 내용 조회
    dispatch(
      getNotificationDuty({
        productType: notificationType,
        insuredCustNo: insuredPrspCustNo,
        callback: checkLoadNotificationDuty,
      }),
    );

    // 부모 컴포넌트인 NotificationEdit 마운트 후, 탭 초기 선택값 설정.
    setActiveTab('1');
  }, []);

  const checkLoadNotificationDuty = responseData => {
    // 계약전 알릴의무 데이터 존재 여부에 따른 처리
    if (
      !complete &&
      responseData.notificationDuty &&
      responseData.notificationDuty?.productType === notificationType
    ) {
      // 불러오기 가능 여부 판단
      let backUpdata = false;

      if (isEasyProduct) {
        // 간편상품은 간편상품 불러오기만 가능
        backUpdata = true;
      } else if (isAnnuityProduct) {
        // 연금 상품은 간편상품만 불러오기 불가
        if (!isEasyProduct) backUpdata = true;
      } else if (isDementiaProduct) {
        backUpdata = false;
      } else {
        // 일반 상품은 간편상품만 불러오기 불가
        // - 위 if (isEasyProduct) 조건에 이미 간편 상품은 false 이므로 바로 true 설정
        // if (!isEasyProduct) backUpdata = true;
        backUpdata = true;
      }

      if (backUpdata) {
        // 불러오기 가능한 경우
        dispatch(
          showModal({
            visible: true,
            type: 'confirm',
            msg: `직전 3개월 이내 알릴의무란 작성기록이 있습니다. 해당 기록을 불러오시겠습니까? \n단, 알릴의무란 내용 중 추가고지 또는 수정사항이 있다면 반드시 해당 내용을 고지/수정하셔야 하며, 알릴의무 ${
              isMedicalProduct ? '1번' : '1,2번'
            }은 이와 상관없이 재작성하셔야 합니다.`,
            onOk: {
              handle: () =>
                handleLoadNotificationDuty(responseData.notificationDuty),
            },
          }),
        );
      }
    }
  };

  const handleLoadNotificationDuty = notificationDuty => {
    try {
      const loadedNotificationDuty =
        $utils.getLoadedNotificationDuty(notificationDuty);
      const data = {
        type: 'contract',
        data: { ...contract, notificationDuty: loadedNotificationDuty },
      };

      handleChangeEaState(data);
    } catch (error) {
      console.log('handleLoadNotificationDuty() - error', error);
      toastError('알릴의무사항 불러오기에 실패하였습니다.');
    }
  };

  const handleChangeEaState = requestData => {
    dispatch(changeEaState(requestData));

    if (completePage.includes(7)) {
      // 완료된 페이지인 경우 완료상태 해제
      const completePages = completePage.filter(item => 7 !== item);

      dispatch(
        changeEaState({
          type: 'completePage',
          data: [...new Set(completePages)],
        }),
      );
    }
  };

  const handlerChangeNotification = (value, initType) => {
    let requestData = {
      type: 'contract',
      data: {
        ...contract,
        notificationDuty: {
          ...contract.notificationDuty,
          [notificationKey]: {
            ...notificationInfo,
            ...value,
          },
        },
      },
    };

    if (initType === 'decrement') {
      requestData = {
        type: 'contract',
        data: {
          ...requestData.data,
          ReductionAct: {
            selectType: '',
            decrementPeriod: '',
            paymentRate: '',
          },
        },
      };
      const completePdfPages = completePdfPage.filter(item => item !== '1753');
      setTimeout(() => {
        dispatch(
          changeEaState({
            type: 'completePdfPage',
            data: [...new Set(completePdfPages)],
          }),
        );
        !isPracticeMode &&
          setTimeout(() => {
            dispatch(saveEaJsonData({ applicationNo: applicationNo }));
          }, 200);
      }, 200);
    } else if (initType === 'specific') {
      requestData = {
        type: 'contract',
        data: {
          ...requestData.data,
          specificContract: {
            subject: '',
            detail: [],
          },
        },
      };
      const completePdfPages = completePdfPage.filter(item => item !== '1752');
      setTimeout(() => {
        dispatch(
          changeEaState({
            type: 'completePdfPage',
            data: [...new Set(completePdfPages)],
          }),
        );
        !isPracticeMode &&
          setTimeout(() => {
            dispatch(saveEaJsonData({ applicationNo: applicationNo }));
          }, 200);
      }, 200);
    }
    handleChangeEaState(requestData);
  };

  // 타보험사 계약 여부 안내 팝업 노출
  const handleShowModal = msg => {
    dispatch(
      showModal({
        visible: true,
        type: 'info',
        msg: msg,
      }),
    );
  };

  const handleActiveTab = value => {
    if (Number(activeTab) < Number(value)) {
      // 다음탭으로 이동할때 이전탭이 모두 완료된 상태여야 함
      if (value === '2' && isDiseaseDisabled) {
        return;
      } else if (value === '3' && (isDiseaseDisabled || isDriveDisabled)) {
        return;
      } else if (value === '4') {
        if (
          (isEasyProduct || isMedicalProduct) &&
          (isDiseaseDisabled || isDriveDisabled)
        ) {
          return; // 간편상품
        } else if (
          !isEasyProduct &&
          (isDiseaseDisabled || isDriveDisabled || isHobbyDisabled)
        ) {
          return;
        }
      }
    }

    setActiveTab(value);
  };

  //현재 입력데이터 저장 및 다음탭으로 이동
  const handleNextActiveTab = () => {
    handleOnSave();
    if (Number(activeTab) < tabDatas.length) {
      // if (Number(activeTab) < 4 && savingProductYN !== 'Y') {
      let nextTab = Number(activeTab) + 1;
      if ((isEasyProduct || isMedicalProduct) && nextTab === 3) {
        nextTab += 1;
      }

      setActiveTab(String(nextTab));
    }
  };

  // 입력값 store에 저장
  const handleOnSave = () => {
    if (!isPracticeMode)
      dispatch(
        saveEaJsonData({
          applicationNo: applicationNo,
        }),
      );

    // if (Number(activeTab) === 4 || savingProductYN === 'Y') setPopupVisible(true);
    if (tabDatas.length <= Number(activeTab)) setPopupVisible(true);
  };

  // 붙여넣기용 전자 서명 조회
  const handleSearchPasteSignData = () => {
    if (
      !signPasteData.app_form_etc_18_sign_01 ||
      !signPasteData.app_form_etc_18_sign_02
    ) {
      dispatch(
        searchSignatureData({
          applicationNo: applicationNo,
          custNo: planMainInfo.ownerPrspCustNo,
          signGubun: 'P',
          reportId: 'app_form_etc_18',
        }),
      );
    }
  };

  // 각 페이지별 전자 서명 조회
  const handleSearchSignData = () => {
    dispatch(
      searchSignatureData({
        applicationNo: applicationNo,
        signGubun: 'P',
        custNo: planMainInfo.ownerPrspInfo.custNo,
        reportId,
        nameId: 'app_form_06_signid_01',
        signId: 'app_form_06_signid_02',
      }),
    );
  };

  // 알릴의무사항 신계약 저장
  const handleSaveNotificationDutyToNbs = async () => {
    try {
      const jsonData = $utils.makeEaDocDataJson();

      const response = await saveNotificationDutyToNbs({ payload: jsonData });
      const isSuccess = $utils.checkApiSuccess(response);
      if (!isSuccess) throw new Error('신계약 청약 저장 API 실패');

      // API 성공 한 경우, 진행 가능여부 체크 및 보여줄 메시지 확인
      const isNbsSuccess = $utils.checkNbsSuccess(response);
      const message = $utils.getNbsMessage(response);

      // 보여줄 메시지가 있을 경우 노출
      if (message) {
        await new Promise(resolve => alert({ message, onClose: resolve }));
      }

      // 만약 신계약에서 API 결과가 성공으로 내려오지 않았는데,
      // 보여줄 메시지도 안내려왔다면 커스텀 오류 메시지 노출
      else if (!isNbsSuccess)
        toastError(
          '알릴의무사항 저장 결과가 정상적이지 않습니다.\n다음에 다시 시도해주세요.',
        );

      return isNbsSuccess;
    } catch (error) {
      console.log('handleSaveNotificationDutyToNbs() - error', error);
      toastError('알릴의무사항 저장에 실패하였습니다.');
      return false;
    }
  };

  // json 저장 및 다음페이지 이동
  const handleSaveNext = async (signNameData, signatureData) => {
    // 알릴의무사항 신계약 저장 API 호출 - 실패 시, 진행 불가
    const isNextAvailable = await handleSaveNotificationDutyToNbs();
    if (!isNextAvailable) return;

    setPopupVisible(false);

    // 서명 서버 저장
    if (!isPracticeMode)
      dispatch(
        saveSignBothData({
          applicationNo: applicationNo,
          signNameData: signNameData,
          signatureData: signatureData,
          signGubun: 'P',
          reportId,
          nameId: `${reportId}_signid_01`,
          signId: `${reportId}_signid_02`,
          callback: callbackSuccess,
        }),
      );
    else {
      dispatch(
        changeEaState({
          type: 'signData',
          data: {
            ...signDataDefatult,
            app_form_06: {
              app_form_06_signid_01: signNameData, // 계약전알릴의무  성명
              app_form_06_signid_02: signatureData, // 계약전알릴의무  서명
            },
          },
        }),
      );
      callbackSuccess(true);
    }
  };

  const callbackSuccess = type => {
    if (type) {
      const completePages = [...completePage, 7];
      dispatch(
        changeEaState({
          type: 'completePage',
          data: [...new Set(completePages)],
        }),
      );
      !isPracticeMode &&
        setTimeout(() => {
          dispatch(saveEaJsonData({ applicationNo: applicationNo }));
        }, 200);

      onClickEaBookmark(bookmark[0]?.pn);
    }
  };

  // 탭 active시에 렌더링하도록 처리.
  const tabPaneRender = type => (
    <React.Fragment>
      <div className="app-wrap">
        <div className="app-box">
          <div className="app-scroll" id="notificationScroll">
            {/* 질병 */}
            {type.value === '1' && activeTab === '1' && (
              <DiseaseInfo
                genderLabel={genderLabel}
                category1={
                  notificationInfo.category1

                  // isEasyProduct
                  //   ? contract.notificationDuty.notificationType2.category1 // 간편상품
                  //   : isAnnuityProduct
                  //   ? contract.notificationDuty.notificationType3.category1 // 연금상품
                  //   : contract.notificationDuty.notificationType1.category1 // 일반상품
                }
                planEstablishProduct={planEstablishProduct}
                isDisabled={isDiseaseDisabled}
                isEasyProduct={isEasyProduct}
                isMedicalProduct={isMedicalProduct}
                isFreePickProduct={isFreePickProduct}
                isSecondMajorRider={isSecondMajorRider}
                isDementiaProduct={isDementiaProduct}
                isAddNoticeQ6={isAddNoticeQ6}
                isBeforeRevision={isBeforeRevision}
                setIsDisabled={setIsDiseaseDisabled}
                onChange={handlerChangeNotification}
                onNext={handleNextActiveTab}
              />
            )}

            {/* 운전 */}
            {type.value === '2' && activeTab === '2' && (
              <DriveInfo
                drvCd={customer.insured.drvCode}
                jobCd={customer.insured.jobCode}
                category1={
                  notificationInfo.category1

                  // isEasyProduct &&
                  // contract.notificationDuty.notificationType2.category1
                }
                category2={
                  notificationInfo.category2

                  // isAnnuityProduct
                  //   ? contract.notificationDuty.notificationType3.category2
                  //   : contract.notificationDuty.notificationType1.category2
                }
                isEasyProduct={isEasyProduct}
                isDisabled={isDriveDisabled}
                setIsDisabled={setIsDriveDisabled}
                onChange={handlerChangeNotification}
                onNext={handleNextActiveTab}
              />
            )}

            {/* 취미 */}
            {type.value === '3' && activeTab === '3' && (
              <HobbyInfo
                category3={
                  notificationInfo.category3

                  // isAnnuityProduct
                  //   ? contract.notificationDuty.notificationType3.category3
                  //   : contract.notificationDuty.notificationType1.category3
                }
                onChange={handlerChangeNotification}
                onNext={handleNextActiveTab}
                isDisabled={isHobbyDisabled}
                setIsDisabled={setIsHobbyDisabled}
              />
            )}

            {/* 기타*/}
            {type.value === '4' && activeTab === '4' && (
              <EtcInfo
                category1={
                  notificationInfo.category1

                  // isEasyProduct &&
                  // contract.notificationDuty.notificationType2.category1
                }
                category4={
                  notificationInfo.category4

                  // isAnnuityProduct
                  //   ? contract.notificationDuty.notificationType3.category4
                  //   : contract.notificationDuty.notificationType1.category4
                }
                startdate={
                  notificationInfo.category4?.q04?.startdate

                  // contract?.notificationDuty?.notificationType3?.category4 &&
                  // (isAnnuityProduct
                  //   ? contract.notificationDuty.notificationType3.category4.q04
                  //       ?.startdate
                  //   : contract.notificationDuty.notificationType1.category4.q04
                  //       ?.startdate)
                }
                enddate={
                  notificationInfo.category4?.q04?.enddate

                  // contract.notificationDuty.notificationType3.category4 &&
                  // (isAnnuityProduct
                  //   ? contract.notificationDuty.notificationType3.category4.q04
                  //       ?.enddate
                  //   : contract.notificationDuty.notificationType1.category4.q04
                  //       ?.enddate)
                }
                onChange={handlerChangeNotification}
                showModal={handleShowModal}
                onNext={handleNextActiveTab}
                suitabilityInfo={suitabilityInfo}
                suitabilityIncome={suitabilityIncome}
                isStbltDgnsProcExcpt={isStbltDgnsProcExcpt}
                isProFinance={isProFinance}
                isPassCustomerMinor={isPassCustomerMinor}
                isEasyProduct={isEasyProduct}
                isMedicalProduct={isMedicalProduct}
                isBeforeRevision={isBeforeRevision}
              />
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );

  return (
    <React.Fragment>
      <EaHeader
        title={`2. 계약 정보 확인 및 작성 - 계약 전 알릴 의무`}
        isFirstPage={false}
        isPracticeMode={isPracticeMode}
      />
      <div className={`con-wrap bg-gray no-bottom`}>
        <div className="app-wrap">
          <SatTab
            activeTab={activeTab}
            onChange={value => handleActiveTab(value)}
            customStyleClass={'tab-check-info'}
          >
            {tabDatas.map(tabData => {
              return (
                <SatTab.TabPane key={tabData.value} tab={tabData}>
                  {tabPaneRender(tabData)}
                </SatTab.TabPane>
              );
            })}
          </SatTab>
        </div>
      </div>
      <SatModal
        visible={popupVisible}
        setVisible={() => {
          setPopupVisible(false);
        }}
        type="info"
        wide
        isNotification={true}
      >
        <NotificationPopup
          searchSignData={handleSearchSignData}
          searchPasteSignData={handleSearchPasteSignData}
          ownerName={planMainInfo.ownerPrspInfo.name}
          empName={empName}
          signPasteData={signPasteData}
          signData={signData}
          onSave={handleSaveNext}
          completePage={completePage}
          isPracticeMode={isPracticeMode}
          practiceSignName={practiceSignName}
          practiceSignature={practiceSignature}
        />
      </SatModal>
    </React.Fragment>
  );
};

export default NotificationEdit;
